import {
  Award,
  BadgeCheck,
  Box,
  Check,
  ChevronDown,
  Cog,
  Droplets,
  Factory,
  FileText,
  FlaskConical,
  Gem,
  GitCompareArrows,
  Globe2,
  Handshake,
  Link,
  Mail,
  MapPin,
  Menu,
  Package,
  Phone,
  Play,
  Search,
  Send,
  ShieldCheck,
  Ship,
  ShoppingBag,
  Truck,
  Users,
  Wheat,
  Wrench,
  X,
  Video,
  type LucideIcon,
} from "lucide-react";

const icons: Record<string, LucideIcon> = {
  award: Award,
  "badge-check": BadgeCheck,
  box: Box,
  check: Check,
  "chevron-down": ChevronDown,
  cog: Cog,
  consulting: Send,
  factory: Factory,
  droplets: Droplets,
  file: FileText,
  flask: FlaskConical,
  gem: Gem,
  globe: Globe2,
  compare: GitCompareArrows,
  handshake: Handshake,
  linkedin: Link,
  mail: Mail,
  map: MapPin,
  menu: Menu,
  package: Package,
  phone: Phone,
  play: Play,
  search: Search,
  "search-users": Users,
  "shield-check": ShieldCheck,
  ship: Ship,
  shopping: ShoppingBag,
  truck: Truck,
  twitter: Send,
  users: Users,
  wheat: Wheat,
  wrench: Wrench,
  x: X,
  youtube: Video,
};

export function Icon({ name, size = 20, strokeWidth = 1.8, className }: { name: string; size?: number; strokeWidth?: number; className?: string }) {
  const Glyph = icons[name] ?? Globe2;
  return <Glyph aria-hidden="true" className={className} size={size} strokeWidth={strokeWidth} />;
}
